import { render, staticRenderFns } from "./DcjCompleteness.vue?vue&type=template&id=67aa59c2&"
import script from "./DcjCompleteness.vue?vue&type=script&lang=ts&"
export * from "./DcjCompleteness.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports